export const fetchCohortSurveyChildListStart = (state, payload) => {
    return {
        ...state,
        fetchCohortSurveyChildListingApi: {
            ...state.fetchCohortSurveyChildListingApi,
            [payload.projectId]: {
                ...state.fetchCohortSurveyChildListingApi[payload.projectId],
                isProcessing: true,
                error: false, reason: '',
                pageNumber: payload.from ? (payload.from / 10) + 1 : 1,
                sortField: payload.sortField ? payload.sortField : "projectName.keyword",
                sortOrder: payload.sortOrder ? payload.sortOrder : "ascend",

            },
            isProcessing: true,
            error: false, reason: '',
        },
    };
};

export const fetchCohortSurveyChildListSuccess = (state, payload) => {
    return {
        ...state,
        fetchCohortSurveyChildListingApi: {
            ...state.fetchCohortSurveyChildListingApi,
            [payload.payload.projectId]: {
                ...state.fetchCohortSurveyChildListingApi[payload.payload.projectId],
                isProcessing: false,
                error: false, reason: '',
                data: payload.data.data.hits,
                count: payload.data.data.total
            },
            isProcessing: false,
            error: false, reason: '',
        },
    };
};

export const fetchCohortSurveyChildListFail = (state, payload) => {
    return {
        ...state,
        fetchCohortSurveyChildListingApi: {
            ...state.fetchCohortSurveyChildListingApi,
            isProcessing: false,
            error: true,
            reason: payload.error,
        },
    };
};
